"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("../store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
var isFolderOrSubFolderOfDistinguishedFolder_1 = require("./isFolderOrSubFolderOfDistinguishedFolder");
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderUnderDeletedFolder(folder, state) {
    return isFolderOrSubFolderOfDistinguishedFolder_1.isUnderDistinguishedFolder(folder, 'deleteditems', state);
});
//# sourceMappingURL=isFolderUnderDeletedFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/utils/isFolderUnderDeletedFolder.js
// module id = 3169
// module chunks = 23 62